import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-511a6307"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sdds-row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total File Rows: ", -1))
const _hoisted_3 = {
  key: 1,
  class: "sdds-row"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Rows with an Error: ", -1))
const _hoisted_5 = {
  key: 2,
  class: "sdds-row sdds-row-separator"
}
const _hoisted_6 = { class: "sdds-table sdds-table--compact sdds-table-output" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "sdds-table__header" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "sdds-table__row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      id: "col-action",
      class: "sdds-table__header-cell sdds-compact"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      id: "col-action",
      class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2 sdds-compact-col"
    }, "Row"),
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2" }, "Error")
  ])
], -1))
const _hoisted_8 = { class: "sdds-table__body" }
const _hoisted_9 = {
  class: "sdds-table__row",
  "data-test-id": "dataRowError"
}
const _hoisted_10 = { class: "" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  class: "sdds-u-pl2 sdds-u-pr2",
  "data-test-id": "rowNumber"
}
const _hoisted_15 = { class: "sdds-table__body-cell sdds-u-pl2 sdds-u-pr2" }
const _hoisted_16 = {
  key: 0,
  class: "sdds-table__row",
  "data-test-id": "dataRowErrorDetail"
}
const _hoisted_17 = {
  class: "sdds-table__body-cell",
  colspan: "3"
}
const _hoisted_18 = { class: "sdds-ul" }
const _hoisted_19 = {
  key: 0,
  class: "sdds-table__footer"
}
const _hoisted_20 = { class: "sdds-table__footer-row" }
const _hoisted_21 = {
  class: "sdds-table__footer-cell",
  colspan: "4"
}
const _hoisted_22 = { class: "sdds-table__pagination" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sdds-table__row-selector" }, null, -1))
const _hoisted_24 = { class: "sdds-table__page-selector" }
const _hoisted_25 = ["max"]
const _hoisted_26 = { class: "sdds-table__footer-text" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" of ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" pages ")
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sdds-table__footer-btn-svg",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.217 4.273a1 1 0 0 1 0 1.415l-9.888 9.888a.6.6 0 0 0 0 .848l9.888 9.888a1 1 0 0 1-1.414 1.415l-9.889-9.889a2.6 2.6 0 0 1 0-3.677l9.889-9.888a1 1 0 0 1 1.414 0Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sdds-table__footer-btn-svg",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.783 27.727a1 1 0 0 1 0-1.415l9.888-9.888a.6.6 0 0 0 0-.848L9.783 5.688a1 1 0 0 1 1.414-1.415l9.889 9.889a2.6 2.6 0 0 1 0 3.676l-9.889 9.889a1 1 0 0 1-1.414 0Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 3,
  class: "sdds-row sdds-row-separator"
}
const _hoisted_36 = { class: "sdds-table sdds-table--compact sdds-table--divider sdds-table-output" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "sdds-table__header" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "sdds-table__row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2",
      colspan: "2"
    }, " Fields mapped as below")
  ])
], -1))
const _hoisted_38 = { class: "sdds-table__body" }
const _hoisted_39 = { class: "sdds-table__row" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "rowNumber: ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Error: ", -1))
const _hoisted_43 = { key: 1 }

import { computed, ref } from 'vue'
import che_down from '../assets/chevron_down.svg';
import che_up from '../assets/chevron_up.svg';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FileImporterOutput',
  props: {
  fileType: {
    type: String,
    default: null,
    required: true,
  },
  jsonOutput: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const props = __props




const jsonData = ref(props.jsonOutput)

const listShowValids = computed(() => {
  return jsonData.value.filter((item) => !item.error).slice(0, 2);
});

const listShowErrors = computed(() => {
  return jsonData.value.filter((item) => item.error);
});


const currentPage = ref(1);
const elementsPerPage = 5;

const get_rows = () => {
  var start = (currentPage.value - 1) * elementsPerPage;
  var end = start + elementsPerPage;
  return listShowErrors.value.slice(start, end);
}
const num_pages = () => {
  return Math.ceil(listShowErrors.value.length / elementsPerPage);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.jsonOutput.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(__props.jsonOutput.length), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(listShowErrors).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_unref(listShowErrors).length), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(listShowErrors).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("tbody", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(get_rows(), (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("tr", _hoisted_9, [
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "sdds-btn sdds-btn-sm sdds-btn-ghost",
                        onClick: ($event: any) => (item.visible = !item.visible),
                        "data-test-id": "btviewDetails"
                      }, [
                        _createElementVNode("span", null, [
                          (!item.visible)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _unref(che_down)
                              }, null, 8, _hoisted_12))
                            : _createCommentVNode("", true),
                          (item.visible)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _unref(che_up)
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_11)
                    ]),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.data.rowNumber), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(item.error), 1)
                  ]),
                  (item.visible)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("ul", _hoisted_18, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(item.data), ([subKey, value]) => {
                              return (_openBlock(), _createElementBlock("li", { key: subKey }, [
                                _createElementVNode("strong", null, _toDisplayString(subKey) + ": ", 1),
                                _createElementVNode("span", null, _toDisplayString(value), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            (num_pages() > 1)
              ? (_openBlock(), _createElementBlock("tfoot", _hoisted_19, [
                  _createElementVNode("tr", _hoisted_20, [
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("input", {
                            class: "sdds-table__page-selector-input sdds-input-numberpage",
                            type: "number",
                            min: "1",
                            id: "num-page",
                            max: num_pages(),
                            pattern: "[0-9]+",
                            dir: "rtl",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event))
                          }, null, 8, _hoisted_25), [
                            [_vModelText, currentPage.value]
                          ]),
                          _createElementVNode("p", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("span", null, _toDisplayString(num_pages()), 1),
                            _hoisted_28
                          ]),
                          _createElementVNode("button", {
                            class: "sdds-table__footer-btn",
                            disabled: currentPage.value <= 1,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value--))
                          }, _hoisted_31, 8, _hoisted_29),
                          _createElementVNode("button", {
                            "data-test-id": "btNextPage",
                            class: "sdds-table__footer-btn",
                            disabled: currentPage.value >= num_pages(),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (currentPage.value++))
                          }, _hoisted_34, 8, _hoisted_32)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(listShowValids).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("table", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("tbody", _hoisted_38, [
              _createElementVNode("tr", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listShowValids), (item, key) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: key,
                    class: "sdds-table__body-cell sdds-u-pl2 sdds-u-pr2",
                    "data-test-id": "dataRowExample"
                  }, [
                    (item.error)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_40, [
                          _createElementVNode("li", null, [
                            _createElementVNode("span", null, [
                              _hoisted_41,
                              _createTextVNode(" " + _toDisplayString(item.data.rowNumber), 1)
                            ])
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("span", null, [
                              _hoisted_42,
                              _createTextVNode(" " + _toDisplayString(item.error), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!item.error)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_43, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(item.data), (subKey) => {
                            return (_openBlock(), _createElementBlock("li", { key: subKey }, [
                              _createElementVNode("strong", null, _toDisplayString(subKey) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(item.data[subKey]), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})